/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import DefaultLayout from 'src/layouts/DefaultLayout';
import MdxBlogPostTemplate from '../../templates/mdxBlogPost';
import {AxeptioWrapper} from '../../components/Common';
const MDXLayout = ({children, location, pageContext}) => _jsx(DefaultLayout, {
  location: location,
  children: _jsx(MdxBlogPostTemplate, {
    location: location,
    pageContext: pageContext,
    children: children
  })
});
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    p: "p",
    blockquote: "blockquote",
    strong: "strong",
    em: "em",
    hr: "hr"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "Hier spielt die Musik..."
    }), "\n", _jsx(_components.p, {
      children: "Der gute alte Schiller hatte vermutlich nicht ganz unrecht, als er schrieb:"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: _jsx(_components.em, {
            children: "„Es schwinden jedes Kummers Falten, solang des Liedes Zauber walten.“"
          })
        })
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Egal, welche kopfzerbrechende Aufgabe man vor sich hat: Ohne musikalische Untermalung wäre die nerdigste Frickelei nur halb so schön. Und auch in den Pausen, auf der Zielgeraden und in Kreativprozessen spielt bei uns die Musik =)"
    }), "\n", _jsx(_components.p, {
      children: "Deshalb haben wir uns dazu entschieden, von Zeit zu Zeit einige Songs aus unseren aktuellen Playlisten oder persönliche Evergreens mit euch zu teilen."
    }), "\n", _jsx("h2", {
      class: "text-center",
      children: _jsxs(_components.p, {
        children: [_jsx("em", {
          class: "fa fa-music"
        }), " Hit the home stretch\n", _jsx("small", {
          children: "Musik, die auf den letzten Metern vorm Wochenende passt"
        })]
      })
    }), "\n", _jsxs("div", {
      class: "spotify justify-content-center flex flex-wrap gap-4",
      children: [_jsx(AxeptioWrapper, {
        slug: "spotify",
        children: _jsxs("div", {
          children: [_jsx("iframe", {
            src: "https://open.spotify.com/embed/track/0kdli9bGgWufvIgeKtmtF5",
            width: "300",
            height: "380",
            frameborder: "0",
            allowtransparency: "true",
            allow: "encrypted-media"
          }), _jsx("p", {
            children: _jsx(_components.p, {
              children: "Diesen Song habe ich nur zufällig entdeckt. Easy Einstieg ins Wochenende\nmit schönem Beat und Gesang."
            })
          })]
        })
      }), _jsx(AxeptioWrapper, {
        slug: "spotify",
        children: _jsxs("div", {
          children: [_jsx("iframe", {
            src: "https://open.spotify.com/embed/track/4sL9zF71OyDJn1YCIMaMmX",
            width: "300",
            height: "380",
            frameborder: "0",
            allowtransparency: "true",
            allow: "encrypted-media"
          }), _jsx("p", {
            children: _jsx(_components.p, {
              children: "Róisín Murphy ist seit Jahren ganz weit oben in meiner Playlist. Es gibt\nein dutzend Klassiker und auch dieser neue Song ist megaaaa..."
            })
          })]
        })
      }), _jsx(AxeptioWrapper, {
        slug: "spotify",
        children: _jsxs("div", {
          children: [_jsx("iframe", {
            src: "https://open.spotify.com/embed/track/2o5hKYuPCTAM7C2zC9wxKw",
            width: "300",
            height: "380",
            frameborder: "0",
            allowtransparency: "true",
            allow: "encrypted-media"
          }), _jsx("p", {
            children: "Hierzu mag ich Tanzen gehen und zwar... genau jetzt!"
          })]
        })
      })]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Danke Franck für das Teaserbild: Photo by Franck V. on Unsplash"
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
